import React from 'react';
import List from './List';

class FilterBoard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chosen_categories: [],
            arr_prywatne_clicked: [],
            arr_firmowe_clicked: [],
            prywatne: {},
            firmowe: {}
        }
    }

    handleCheckbox = (event) => {
        const {prywatne, firmowe} = this.props;
        
        let {chosen_categories, arr_prywatne_clicked, arr_firmowe_clicked} = this.state

        let chosen_category = event.target.value
        let prywatne_index = null;
        let firmowe_index = null;

        prywatne.map((item, index) => {
            if(item.slug === chosen_category) {
                prywatne_index = index
            }
            return prywatne_index
        })

        firmowe.map((item, index) => {
            if(item.slug === chosen_category) {
                firmowe_index = index
            }
            return firmowe_index
        })
        
        
        if (chosen_categories.indexOf(chosen_category) === -1) {
            chosen_categories.push(chosen_category);
        } else {
            chosen_categories.splice(chosen_categories.indexOf(chosen_category), 1);
        }   

        if (arr_prywatne_clicked.length === 0) {
            for(let i=0; i<prywatne.length; i++)
                arr_prywatne_clicked.push(false);
        }
        if (arr_firmowe_clicked.length === 0) {
            for(let i=0; i<firmowe.length; i++)
                arr_firmowe_clicked.push(false);
        }

        if (prywatne_index >= 0) {
            arr_prywatne_clicked[prywatne_index] = !arr_prywatne_clicked[prywatne_index]
        } 
        if (firmowe_index >= 0) {
            arr_firmowe_clicked[firmowe_index] = !arr_firmowe_clicked[firmowe_index]
        }
        this.setState({
            chosen_categories: chosen_categories,
            arr_prywatne_clicked: arr_prywatne_clicked,
            arr_firmowe_clicked: arr_firmowe_clicked,
            prywatne_index: prywatne_index,
            firmowe_index: firmowe_index,
            prywatne: prywatne,
            firmowe: firmowe
        })
    }

    submitFilter = (event) => {
        this.props.handleSubmitFilter(this.state.chosen_categories);
        event.preventDefault();
    }

    render() {
    const {filter_open, prywatne, firmowe} = this.props
    const {arr_prywatne_clicked, arr_firmowe_clicked} = this.state 
    if (!filter_open) {
        return null;
    }
        return(
            <div className="well display-slow">
                    <form>
                    <fieldset>
                        <legend>Uwzględniaj po wybranych kategoriach</legend>
                        <p className="help-block">Brak wybranych kategorii oznacza wyświetlenie wszystkich dostępnych</p>
                        <div className="row">
                            <List 
                                title={'Prywatne'}
                                sorted_categories={prywatne} 
                                clicked={arr_prywatne_clicked}
                                handleCheckbox={this.handleCheckbox}
                            />
                            <List 
                                title={'Firmowe'}
                                sorted_categories={firmowe} 
                                clicked={arr_firmowe_clicked}
                                handleCheckbox={this.handleCheckbox}
                            />
                        </div>
                    </fieldset>
                    <div className="top-buffer text-center">
                        <button onClick={this.submitFilter} className="btn btn-info">Filtruj</button>
                    </div>
                </form>
                </div>
        )
    }
}


export default FilterBoard;